import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundComment.Delete.IRequest;
type Response = Api.Sales.ContractRefundComment.Delete.IResponse;
type Headers = Api.Sales.ContractRefundComment.Delete.IHeaders;
const url = '/api/Sales/ContractRefundComment/:id';
export default async function contractRefundCommentDeleteApi({ id }: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
